/**
 * @author Johann Kowalski (traal-devel) <devel@traal.ch>
 */


import { Component, OnDestroy, OnInit } from '@angular/core';
import { HlsStreamPipe } from 'src/app/shared/pipe/hls-stream.pipe';
import { EpgService } from 'src/app/service/epg.service';
import { TvfAuthService } from 'src/app/service/tvf-auth.service';
import { AssetItem, AssetsListResponse, ChannelStreamResponse, EpgListResponse } from 'tvf-rest-client';
import * as Plyr from 'plyr';
import * as Hls from 'hls.js';
import { ChannelProgram } from 'projects/tvf-rest-client/src';

@Component({
  selector: 'app-epg-tile',
  templateUrl: './epg-tile.component.html',
  styleUrls: ['./epg-tile.component.css']
})
export class EpgTileComponent implements OnInit, OnDestroy {


  /* member variables */
  detailIndex = -1;

  channelList = [];
  epgCurrentList: ChannelProgram[];

  player: Plyr = null;
  hls: Hls  = null;

  /* constructors */
  constructor(
    private tvfAuthService: TvfAuthService,
    private epgService: EpgService,
    private hlsStreamPipe: HlsStreamPipe,
  ) { }


  /* methods */
  ngOnInit(): void {
    // ensure that access token is present in the http headers
    this.tvfAuthService.checkAutoLogin();

    this.initEpgList();
  }

  ngOnDestroy() {
    console.log("destroy");
    this.closeStream();
  }

  initEpgList(): void {
    this.epgService
      .getTvChannelListOrdered()
      .subscribe((value: AssetsListResponse) => {
        this.channelList = [
          ...this.channelList,
          ...value.data,
        ];
      }
    );
  }

  closeChannel(): void {
    this.closeStream();
    this.channelList.splice(this.detailIndex, 1);
    this.detailIndex = -1;
  }

  closeStream(): void{
    if (this.player != null) {
      this.player.stop();
      this.player.destroy();
      this.player = null;
    }

    if (this.hls != null) {
      console.log("close hls stream");
      this.hls.stopLoad();
      this.hls.destroy();
      this.hls = null
    }
  }

  showChannel(index: number): void {
    const tmpRef = this.channelList[index];
    if (this.detailIndex > -1) {
      this.channelList.splice(this.detailIndex, 1);
      index = index - 1;
    }
    this.detailIndex = (Math.floor((index) / 8)) * 8;
    this.channelList.splice(this.detailIndex, 0, tmpRef);
    this.channelList = [
      ...this.channelList,
    ];

    // Workaround: Wait, till video element is added to dom tree.
    setTimeout(() => {
      const video = document.querySelector('video') as HTMLVideoElement;
      this.initPlyr(
        this.channelList[this.detailIndex],
        video
      );
    });
    this.initEpg();
  }

  private initEpg(): void {
    this.epgService
      .getNextThreeLiveEvents(
        this.channelList[this.detailIndex].id
      )
      .subscribe((value: EpgListResponse) => {
        this.epgCurrentList = value.data;
      });
  }


  private initPlyr(
    assetItem: AssetItem,
    video: HTMLVideoElement
  ): void {
    const rHlsStream = this.hlsStreamPipe.transform(assetItem.resources);

    this.closeStream();
    this.player = new Plyr(video, {
      captions: {
        active: true,
        update: true,
        language: 'en'
      },
      controls: [
        'play-large', // The large play button in the center
        'play', // Play/pause playback
        // 'duration', // The full duration of the media
        'mute', // Toggle mute
        'volume', // Volume control
        'captions', // Toggle captions
        'settings', // Settings menu
        'fullscreen', // Toggle fullscreen
      ], 
      "autoplay": true
    });


    if (!Hls.isSupported()) {
      alert('HLS is NOT supported');
    } else {
      this.epgService.getChannelStream(
        assetItem.id,
        rHlsStream.id
      ).subscribe((response: ChannelStreamResponse) => {
        const hlsOptions = { xhrSetup: xhr => { } };
        this.hls = new Hls(hlsOptions);
        this.hls.loadSource(response.data);
        this.hls.attachMedia(video);
        // Handle changing captions
        // this.player.on('languagechange', () => {
        //   // Caption support is still flaky. See: https://github.com/sampotts/plyr/issues/994
        //   setTimeout(() => this.hls.subtitleTrack = this.player.currentTrack, 50);
        // });
      });
    }
  }
}
